module.exports = __webpack_public_path__ + "img/IconHome.bad0bdcf.svg";